import { render, staticRenderFns } from "./MyShippingDetails.vue?vue&type=template&id=f6a3c1f8&scoped=true"
import script from "./MyShippingDetails.vue?vue&type=script&lang=js"
export * from "./MyShippingDetails.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./MyShippingDetails.vue?vue&type=style&index=0&id=f6a3c1f8&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f6a3c1f8",
  "426001f2"
  
)

export default component.exports